import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IBreadcrumb } from '../models';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<IBreadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  setBreadcrumbs(breadcrumbs: IBreadcrumb[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  pushBreadcrumb(text: string, link?: string, callback?: () => void) {
    const current = this.breadcrumbsSubject.value;
    this.breadcrumbsSubject.next([...current, { text, link, callback }]);
  }

  popBreadcrumb() {
    const current = this.breadcrumbsSubject.value;
    if (current.length > 0) {
      this.breadcrumbsSubject.next(current.slice(0, -1));
    }
  }

  clearBreadcrumbs() {
    this.breadcrumbsSubject.next([]);
  }

  getBreadcrumbs() {
    return this.breadcrumbsSubject.value;
  }
}
